module.exports = __webpack_public_path__ + "img/2400m.e8409011.png";